import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=75165eb4"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75165eb4')) {
      api.createRecord('75165eb4', component.options)
    } else {
      api.reload('75165eb4', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=75165eb4", function () {
      api.rerender('75165eb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/account/views/Notifications.vue"
export default component.exports